/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2023 - 2023
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { format } from "date-fns";

import { dateFormat, division as userDivision } from "../../../helpers/types";
import { FormattedMessage } from "react-intl";
import messages from "../../../helpers/messages";
import AccessTimeIcon from "../../icons/AccessTimeIcon";

function PendingProcurementReviewState({ summary, division }) {
  const { closeDateUTC } = summary;
  const date = format(
    new Date(closeDateUTC),
    division === userDivision.coy ? dateFormat.MMddyy : dateFormat.ddMMyy
  );

  return (
    <>
      <p className="inline-block font-size-14 pt-16 mb-0">
        <FormattedMessage
          {...messages.lanesHaveBeenImportedMessage}
          values={{ date: date }}
        />
      </p>
      <div
        className="fr pt-16 inline-block mb-0 weight--semibold mr-8"
        id="pending-procurement-review"
      >
        <AccessTimeIcon
          className="align-text-bottom mr-8"
          height={12}
          width={12}
          fill="#000000"
        />
        {messages.pendingProcurementReview.defaultMessage}
      </div>
    </>
  );
}

export default PendingProcurementReviewState;
